import {
  availabilityModes,
  returnReasonsFilteringTypes,
} from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonDetailConfiguration/constants'

export const allProducts = availabilityModes.all

export const filterOptionsConfig = [
  {
    label: 'Todos los productos',
    value: allProducts,
  },
  {
    label: 'Solo para los tipos de producto seleccionados',
    value: availabilityModes.productTypes,
    filteringType: returnReasonsFilteringTypes.productTypes,
  },
  {
    label: 'Solo para las categorías de producto seleccionadas',
    value: availabilityModes.productCategories,
    filteringType: returnReasonsFilteringTypes.productCategories,
  },
  {
    label: 'Solo para productos con las etiquetas seleccionadas',
    value: availabilityModes.productTags,
    filteringType: returnReasonsFilteringTypes.productTags,
  },
  {
    label: 'Tipos de producto no excluidos',
    value: availabilityModes.nonExcludedProductTypes,
    filteringType: returnReasonsFilteringTypes.productTypes,
  },
  {
    label: 'Categorías de producto no excluidas',
    value: availabilityModes.nonExcludedProductCategories,
    filteringType: returnReasonsFilteringTypes.productCategories,
  },
  {
    label: 'Tags de producto no excluidos',
    value: availabilityModes.nonExcludedProductTags,
    filteringType: returnReasonsFilteringTypes.productTags,
  },
]
